/**
 * 加载更多骨架屏组件
 *
 * CLS 优化：为 RecentFollow 分页加载提供布局稳定的骨架屏
 *
 * 问题：点击 "Load More Truth" 后，在数据返回前列表高度不变，
 * 数据返回后列表突然增长，导致下方内容位移，造成 CLS 问题。
 *
 * 解决：在加载更多时，在列表末尾显示骨架屏预留空间，
 * 数据返回后平滑替换为真实内容。
 */
import { Skeleton } from 'antd';
import styles from '../index.module.less';
import classNames from 'classnames';

interface LoadMoreSkeletonProps {
  /** 当前列表已有的项数，用于计算排名起始值 */
  startIndex: number;
  /** 预期加载的项数，默认 45（后端每页返回 45 条） */
  count?: number;
}

export default function LoadMoreSkeleton({ startIndex, count = 45 }: LoadMoreSkeletonProps) {
  return (
    <div className={styles['user-list']} style={{ marginBottom: '20px' }}>
      {Array.from({ length: count }, (_, i) => {
        const rank = startIndex + i + 1;
        return (
          <div key={`skeleton-${i}`} className={styles.userItem} style={{ cursor: 'default' }}>
            {/* 排名 - 真实渲染以保持一致性 */}
            <span className={classNames([styles.rank, rank <= 3 && styles['top-3'], 'flex-shrink-0'])}>{rank}</span>
            {/* 头像骨架 - 与真实内容一致: 40x40 */}
            <Skeleton.Avatar active size={40} className="mr-4" />
            {/* 用户信息骨架 */}
            <div className={styles['user-info']}>
              <Skeleton.Input active style={{ width: 120, height: 20, marginBottom: 4 }} />
              <Skeleton.Input active style={{ width: 80, height: 16 }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}
